import { Center } from 'styled-system/jsx';
import InfoCircleIcon from '../../assets/icons/outlineInfoCircle.svg?react';

export default function WalletInfoButton({ onClick }: { onClick: () => void }) {
  return (
    <Center
      p={8}
      m={-8}
      cursor={'pointer'}
      color={'black'}
      css={{
        '& svg': { width: '16px', height: '16px' },
        '& svg path': { fill: 'currentColor' },
      }}
      onClick={onClick}
    >
      <InfoCircleIcon />
    </Center>
  );
}
